import { QuestionTitle } from '@/components/decision-tree/components/SurveyItem/components/Question/components/QuestionTitle';
import { Box, InlineAlert, Input } from '@cmpsr/components';
import { FC, useEffect, useRef } from 'react';
import useEmailController from './Email.controller';
import { EmailAnswer, EmailProps } from './types';

export const Email: FC<EmailProps> = ({ data, saveAnswer, defaultValue, whyWeAskModalDisclosure }) => {
  const { label, id, placeholder, whyWeAskExplanation, tooltip, description, validationValues } = data;
  const { form, onInputFn, validationOptions, onBlurFn } = useEmailController({
    validationValues,
    saveAnswer,
    defaultValue,
  });

  // Use a ref to track if we've already saved the default value
  const initialSaveDone = useRef(false);

  // If we have a default value, ensure it's saved only on initial render
  useEffect(() => {
    if (defaultValue?.value && !initialSaveDone.current) {
      saveAnswer({ type: 'email', value: defaultValue.value });
      initialSaveDone.current = true;
    }
  }, [defaultValue, saveAnswer]);

  return (
    <Box as="form" maxWidth="450px">
      <QuestionTitle
        description={description}
        tooltip={tooltip}
        question={label}
        whyWeAskExplanation={whyWeAskExplanation}
        whyWeAskModalDisclosure={whyWeAskModalDisclosure}
      />
      <Box margin="auto" mt={6}>
        <Input
          key={id}
          variant="outline"
          placeholder={placeholder ?? ''}
          defaultValue={(defaultValue as EmailAnswer)?.value ?? ''}
          borderColor={
            form.formState.errors.email?.message ? 'alert-error-default !important' : 'ui-element-outline-default'
          }
          {...form.register('email', validationOptions)}
          onInput={onInputFn}
          onBlur={onBlurFn}
          type="email"
          textAlign="center"
          autoComplete="email"
        />
        {form.formState.errors.email?.message ? (
          <InlineAlert status="error" mt="spacer-6" mb="spacer-6" alignItems="flex-start">
            <InlineAlert.Icon />
            <InlineAlert.Message>{form.formState.errors.email?.message}</InlineAlert.Message>
          </InlineAlert>
        ) : null}
      </Box>
    </Box>
  );
};
